import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';

const Channels = ({
  label,
  touched,
  errors,
  channels,
  values,
  setFieldValue
}) => {
  const updatedChannels = channels.map(({ id, description }) => {
    return { id, label: description };
  });

  return (
    <>
      <div className="main-content-form-headers">
        <span className="select-placeholder">{label}*</span>
      </div>
      <div
        style={{ position: 'relative', width: '100%' }}
        className={`frg-select-container color-light input-container ${
          errors.channel && touched.channel ? 'error' : ''
        }`}
      >
        <Typeahead
          id="channel"
          labelKey="label"
          options={updatedChannels}
          onChange={e => {
            setFieldValue('channel', e);
          }}
          selected={values.channel || []}
          clearButton
        />
        <div className="error_messages">
          <span className="frg-body-font-14px">{errors.channel}</span>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
    </>
  );
};

Channels.propTypes = {
  label: PropTypes.string.isRequired,
  touched: PropTypes.shape({
    channel: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  }).isRequired,
  errors: PropTypes.shape({
    channel: PropTypes.string
  }).isRequired,
  channels: PropTypes.arrayOf(PropTypes.object).isRequired,
  values: PropTypes.shape({
    channel: PropTypes.array
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default Channels;
